(function (root) {
  const policy = {
    visit(raw, now, timeout) {
      if (!raw || raw.version !== 2 || !Number.isFinite(raw.lastSeen) || now < raw.lastSeen || now - raw.lastSeen >= timeout) {
        return { version: 2, lastSeen: now, elapsed: 0, shown: false };
      }
      return { version: 2, lastSeen: raw.lastSeen, elapsed: Math.max(0, Number(raw.elapsed) || 0), shown: raw.shown === true };
    },
    advance(raw, now, delta, timeout) {
      const visit = this.visit(raw, now, timeout);
      // Concurrent visible tabs must not double-count the same browsing time.
      visit.elapsed = Math.min(60000, visit.elapsed + Math.max(0, Math.min(delta, now - visit.lastSeen)));
      visit.lastSeen = now;
      return visit;
    },
    eligible(visit, subscribed, delay) { return !subscribed && !visit.shown && visit.elapsed >= delay; },
    blocked({ overlay = false, scrollLocked = false, typing = false } = {}) { return !!(overlay || scrollLocked || typing); },
    excluded(path) { return /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:cart|checkout|checkouts|account|challenge)(?:\/|$)/i.test(path); }
  };
  policy.viewportLength = (value, axis, fallback) => {
    const n = parseFloat(value);
    if (!Number.isFinite(n)) return fallback;
    return String(value).trim().endsWith('%') ? n * axis / 100 : n;
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = policy;
  else root.BobboPopupPolicy = policy;
})(globalThis);

(() => {
  'use strict';
  if (typeof document === 'undefined') return;
  let config = {};
  try { config = JSON.parse(document.getElementById('BobboOfferConfig')?.textContent || '{}'); } catch { /* No promotion without valid configuration. */ }
  window.BobboOffers = { config };
  const policy = window.BobboPopupPolicy;
  const visitKey = 'bobbo_offer_visit_v2';
  const subscribedKey = 'bobbo_offer_subscribed_v2';
  let storage;
  for (const name of ['localStorage', 'sessionStorage']) {
    try { const candidate = window[name]; candidate.setItem('bobbo_offer_storage_check', '1'); candidate.removeItem('bobbo_offer_storage_check'); storage = candidate; break; } catch { /* Fall back when browser storage is unavailable. */ }
  }
  const memory = new Map();
  const read = key => { try { return JSON.parse(storage?.getItem(key) ?? memory.get(key) ?? 'null'); } catch { return null; } };
  const write = (key, value) => { const text = JSON.stringify(value); memory.set(key, text); try { storage?.setItem(key, text); } catch { storage = undefined; } };
function initializePopup(popup) {
  if (popup.dataset.initialized) return;
  popup.dataset.initialized = "true";
  const launcher = document.getElementById("BobboOfferLauncher");
  const forced = new URLSearchParams(location.search).get("bobbo_popup") === "1";
  const success = !!popup.querySelector("[data-offer-success]");
  const returned = success || !!popup.querySelector("[data-offer-errors]");
  const subscribed = () => popup.dataset.subscribed === "true" || read(subscribedKey) === true;
  if (success) write(subscribedKey, true);
  if ((popup.dataset.designMode === "true" && !forced) ||
      (policy.excluded(location.pathname) && !forced) ||
      (subscribed() && !returned && !forced)) return;
  const timeout = Math.max(5, Number(popup.dataset.visitMinutes) || 30) * 60000;
  const delay = Math.max(3, Number(popup.dataset.delay) || 5) * 1000;
  let previousFocus, specialOpened = false, lastTick = Date.now();
  let visit = policy.visit(read(visitKey), lastTick, timeout);
  visit.lastSeen = lastTick;
  write(visitKey, visit);
  const overlayVisible = () => [...document.querySelectorAll('dialog[open],#menuDrawer.is-open,[aria-modal="true"]:not([hidden])')]
    .some(el => el !== popup && el.getClientRects().length && getComputedStyle(el).visibility !== "hidden");
  const coversPurchase = () => {
    if (!launcher) return false;
    const style=getComputedStyle(launcher);
    const width=policy.viewportLength(style.width,innerWidth,38), height=policy.viewportLength(style.minHeight,innerHeight,166);
    const top=policy.viewportLength(style.top,innerHeight,innerHeight*.52), left=document.documentElement.clientWidth-width;
    return [...document.querySelectorAll('[data-reference-add] button[type="submit"],[data-sticky-add],[data-bundle-add],[data-reference-quickadd],.bobbo-checkout')].some(el=>{
      const r=el.getBoundingClientRect();
      return r.width>0 && r.height>0 && r.bottom>top-8 && r.top<top+height+8 && r.right>left-8 && r.left<left+width+8;
    });
  };
  const syncLauncher = () => {
    if (!launcher) return;
    const eligible = (visit.shown || specialOpened) && !success && !subscribed() && !policy.excluded(location.pathname);
    const hidden = !eligible || popup.open || overlayVisible() || document.body.classList.contains("reference-scroll-locked") || coversPurchase();
    if (launcher.hidden !== hidden) launcher.hidden = hidden;
    launcher.setAttribute("aria-expanded", String(popup.open));
  };
  const blocked = () => {
    const typing = document.activeElement?.matches('input,textarea,select,[contenteditable="true"]');
    // A non-modal cookie banner is not a prerequisite for the welcome offer.
    // Consent preferences remain untouched; actual modal dialogs still take priority.
    return policy.blocked({ overlay: overlayVisible(),
      scrollLocked: document.body.classList.contains("reference-scroll-locked"), typing });
  };
  const open = () => {
    if (popup.open || blocked()) return false;
    previousFocus = document.activeElement;
    popup.showModal();
    visit.shown = true;
    write(visitKey, visit);
    specialOpened = true;
    document.body.classList.add("bobbo-popup-open");
    syncLauncher();
    popup.querySelector("[data-offer-close]")?.focus({preventScroll:true});
    return true;
  };
  const close = () => { if (popup.open) popup.close(); };
  popup.querySelectorAll("[data-offer-close]").forEach(button => button.addEventListener("click", close));
  popup.addEventListener("cancel", event => { event.preventDefault(); close(); });
  popup.addEventListener("click", event => {
    if (event.target !== popup) return;
    const r = popup.getBoundingClientRect();
    if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close();
  });
  popup.addEventListener("close", () => {
    document.body.classList.remove("bobbo-popup-open");
    syncLauncher();
    if (!document.querySelector('dialog[open],#menuDrawer.is-open') && previousFocus?.isConnected)
      previousFocus.focus({preventScroll:true});
  });
  launcher?.addEventListener("click", open);
  popup.querySelector("form")?.addEventListener("submit", () => {
    const tags = popup.querySelector("[data-offer-tags]");
    if (tags) tags.value = "newsletter,bobbo_popup";
  });
  const visibility = () => { lastTick = Date.now(); };
  const syncSubscriber = () => {
    if (subscribed() && popup.open && !success && !forced) close();
    syncLauncher();
  };
  let launcherFrame=0;
  const queueLauncher=()=>{if(!launcherFrame)launcherFrame=requestAnimationFrame(()=>{launcherFrame=0;syncLauncher();});};
  window.addEventListener('scroll',queueLauncher,{passive:true});
  window.addEventListener('resize',queueLauncher);
  const observer = new MutationObserver(queueLauncher);
  // Observe only overlay state, never the launcher's own visibility mutations.
  observer.observe(document.body, {attributes:true,attributeFilter:['class']});
  document.querySelectorAll('dialog,#menuDrawer').forEach(el=>observer.observe(el,{attributes:true,attributeFilter:['open','class','hidden']}));
  const cleanup = () => {
    clearInterval(timer);
    observer.disconnect();
    cancelAnimationFrame(launcherFrame);
    window.removeEventListener('scroll',queueLauncher);
    window.removeEventListener('resize',queueLauncher);
    document.removeEventListener("visibilitychange", visibility);
    window.removeEventListener("storage", syncSubscriber);
    document.body.classList.remove("bobbo-popup-open");
  };
  const tick = () => {
    if (!popup.isConnected) { cleanup(); return; }
    const now = Date.now(), delta = Math.min(1000, Math.max(0, now - lastTick));
    lastTick = now;
    if (document.hidden) return;
    visit = policy.advance(read(visitKey), now, delta, timeout);
    write(visitKey, visit);
    syncLauncher();
    if (forced || returned) {
      if (specialOpened) return;
    } else if (!policy.eligible(visit, subscribed(), delay)) return;
    open();
  };
  window.addEventListener("storage", syncSubscriber);
  document.addEventListener("visibilitychange", visibility);
  popup.closest(".shopify-section")?.addEventListener("shopify:section:unload", cleanup, {once:true});
  const timer = setInterval(tick, 500);
  syncLauncher();
}
  const initialize = () => document.querySelectorAll('[data-offer-popup]').forEach(initializePopup);
  initialize();
  document.addEventListener('shopify:section:load', initialize);
  // The copied announcement element has no registered custom-element runtime.
  if (!customElements.get('sht-ann-bar')) {
    document.querySelectorAll('sht-ann-bar').forEach(bar => {
      const track = bar.querySelector('.js-anmb-items');
      if (!track) return;
      track.setAttribute('aria-live', 'off');
      const sync = () => {
        const current = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        [...track.children].forEach((slide, index) => {
          slide.setAttribute('aria-hidden', String(index !== current));
          slide.querySelectorAll('a').forEach(link => link.tabIndex = index === current ? 0 : -1);
        });
      };
      track.addEventListener('scroll', sync, { passive: true });
      requestAnimationFrame(sync);
      const rotation = setInterval(() => {
        if (!bar.isConnected) { clearInterval(rotation); return; }
        if (document.hidden || bar.matches(':hover') || bar.contains(document.activeElement) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const index = (Math.round(track.scrollLeft / track.clientWidth) + 1) % track.children.length;
        track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
      }, 5000);
    });
  }
})();
